Livewire.on('invoiceDescriptionSelected', function (invoiceDescription) {
    if (invoiceDescription === 'closing_invoice') {
        $('#set_status_fc').prop("checked", true);
    } else {
        $('#set_status_fc').prop("checked", false);
    }
});
